<template>
  <BApp>
    <section id="price-list" class="padding-small">
      <div class="container-fluid">
        <div class="row">
          <CategoryFilter v-model="filterComp" :categories />
          <div class="col-lg-8 col-xl-9 sidebar-left">
            <BFormGroup :label="$t('Show columns')">
              <BFormCheckboxGroup
                v-model="columns"
                buttons
                button-variant="outline-primary"
                :options="columnOptions"
              />
            </BFormGroup>

            <div class="table-responsive">
              <table class="table table-striped table-sm" data-sorting="true">
                <thead>
                  <tr>
                    <th>{{ $t('Style') }}</th>
                    <th>{{ $t('Fabric') }}</th>
                    <th>{{ $t('Lining') }}</th>
                    <th>{{ $t('Product') }}</th>
                    <th v-if="columns.includes('custom')">
                      {{ $t('Custom') }}
                    </th>
                    <th v-if="columns.includes('solid')">
                      {{ $t('Solid') }}
                    </th>
                    <th v-if="columns.includes('repeat')">
                      {{ $t('Print') }}
                    </th>
                    <th v-if="columns.includes('grab-bag')">
                      {{ $t('Grab Bag') }}
                    </th>
                    <th v-if="columns.includes('overstock')">
                      {{ $t('Overstock') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="product in filteredItems"
                    :key="product.product.id"
                  >
                    <td>
                      <div v-if="product.product.styleEntity">
                        <a
                          :href="
                            '/styles/' +
                            product.product.styleEntity.id +
                            '/prints'
                          "
                        >
                          <span v-if="product.product.styleEntity.names">
                            {{ localize(product.product.styleEntity.names) }}
                          </span>
                          <br />
                          <img
                            width="75"
                            :src="imgUrl(product.product.styleEntity)"
                            onerror="this.src = '/images/comingsoon.png'"
                          />
                        </a>
                      </div>
                    </td>
                    <td>
                      <div v-if="product.product.fabricEntity">
                        <span v-if="product.product.fabricEntity.names">
                          {{ localize(product.product.fabricEntity.names) }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div v-if="product.product.liningOptionEntity">
                        <span v-if="product.product.liningOptionEntity.names">
                          {{
                            localize(product.product.liningOptionEntity.names)
                          }}
                        </span>
                      </div>
                    </td>
                    <td>{{ product.product.id }}</td>
                    <td
                      v-if="columns.includes('custom') && product.product.sizes"
                    >
                      <div v-if="product.product.sizes.length > 0">
                        <div
                          v-if="
                            product.product.sizes[0].priceClasses.includes(
                              'custom',
                            )
                          "
                        >
                          <template v-if="props.isIndividual">
                            <Price
                              :price="product.prices.custom.retailPrice.amount"
                              tag="s"
                            /><br />
                            <i
                              ><Price
                                :price="product.prices.custom.teamPrice.amount"
                              />
                              {{ $t('12 or more') }}</i
                            >
                          </template>
                          <template v-else>
                            <Price
                              :price="product.prices.custom.retailPrice.amount"
                              tag="s"
                            /><br />
                            <Price
                              :price="
                                product.prices.custom.customerPrice.amount
                              "
                            />
                          </template>
                        </div>
                      </div>
                    </td>
                    <td
                      v-if="columns.includes('solid') && product.product.sizes"
                    >
                      <div v-if="product.product.sizes.length > 0">
                        <div
                          v-if="
                            product.product.sizes[0].priceClasses.includes(
                              'solid',
                            )
                          "
                        >
                          <template v-if="isIndividual">
                            <Price
                              :price="product.prices.solid.retailPrice.amount"
                              tag="s"
                            /><br />
                            <i
                              ><Price
                                :price="product.prices.solid.teamPrice.amount"
                              />
                              {{ $t('12 or more') }}</i
                            >
                          </template>
                          <template v-else>
                            <Price
                              :price="product.prices.solid.retailPrice.amount"
                              tag="s"
                            /><br />
                            <Price
                              :price="product.prices.solid.customerPrice.amount"
                            />
                          </template>
                        </div>
                      </div>
                    </td>
                    <td
                      v-if="columns.includes('repeat') && product.product.sizes"
                    >
                      <div v-if="product.product.sizes.length > 0">
                        <div
                          v-if="
                            product.product.sizes[0].priceClasses.includes(
                              'repeat',
                            )
                          "
                        >
                          <template v-if="isIndividual">
                            <Price
                              :price="product.prices.repeat.retailPrice.amount"
                              tag="s"
                            /><br />
                            <i
                              ><Price
                                :price="product.prices.repeat.teamPrice.amount"
                              />
                              {{ $t('12 or more') }}</i
                            >
                          </template>
                          <template v-else>
                            <Price
                              :price="product.prices.repeat.retailPrice.amount"
                              tag="s"
                            /><br />
                            <Price
                              :price="
                                product.prices.repeat.customerPrice.amount
                              "
                            />
                          </template>
                        </div>
                      </div>
                    </td>
                    <td
                      v-if="
                        columns.includes('grab-bag') && product.product.sizes
                      "
                    >
                      <div v-if="product.product.sizes.length > 0">
                        <div
                          v-if="
                            product.product.sizes[0].priceClasses.includes(
                              'grab-bag',
                            )
                          "
                        >
                          <template v-if="isIndividual">
                            <Price
                              :price="
                                product.prices['grab-bag'].retailPrice.amount
                              "
                            />
                          </template>
                          <template v-else>
                            <Price
                              :price="
                                product.prices['grab-bag'].retailPrice.amount
                              "
                              tag="s"
                            /><br />
                            <Price
                              :price="
                                product.prices['grab-bag'].customerPrice.amount
                              "
                            />
                          </template>
                        </div>
                      </div>
                    </td>
                    <td
                      v-if="
                        columns.includes('overstock') && product.product.sizes
                      "
                    >
                      <div v-if="product.product.sizes.length > 0">
                        <div
                          v-if="
                            product.product.sizes[0].priceClasses.includes(
                              'overstock',
                            )
                          "
                        >
                          <Price
                            :price="product.prices.overstock.retailPrice.amount"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /.col-md-12 -->
        </div>
      </div>
      <!-- /.container -->
    </section>
    <!-- /#content -->
  </BApp>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type Category from '../../common/Category';
import type { PricedProduct } from '../../common/Product';
import _ from 'lodash-es';
import type { Style } from '../../common/CatalogItem';
import CategoryFilter from '../../components/CategoryFilter.vue';
import { BApp, BFormGroup, BFormCheckboxGroup } from 'bootstrap-vue-next';
import { genLocalize, type LocaleDto } from '@agon/shared-utils';
import Price from '../../components/Price.vue';
import { useI18n } from 'vue-i18n';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/style.blue.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

interface Props {
  localeDto: LocaleDto;
  categories: Category[];
  items: PricedProduct[];
  isIndividual: boolean;
  blobDomain: string;
}
const props = defineProps<Props>();

const { t } = useI18n();

const urlParams = new URLSearchParams(window.location.search);
const filterData = ref<Record<string, string[]>>(
  JSON.parse(urlParams.get('filter') ?? '{}'),
);
const columnsData = ref<string[]>(
  JSON.parse(urlParams.get('columns') ?? '["custom"]'),
);

const filterComp = computed({
  get: () => filterData.value,
  set: (newValue: Record<string, string[]>) => {
    const cleaned = Object.fromEntries(
      Object.entries(newValue).filter(([, v]) => v.length > 0),
    );
    filterData.value = cleaned;
    const url = new URL(window.location.toString());
    url.searchParams.set('filter', JSON.stringify(cleaned));
    history.replaceState({}, '', url.toString());
  },
});
const columns = computed({
  get: () => columnsData.value,
  set: (newValue: string[]) => {
    columnsData.value = newValue;
    const url = new URL(window.location.toString());
    url.searchParams.set('columns', JSON.stringify(newValue));
    history.replaceState({}, '', url.toString());
  },
});

const columnOptions = [
  { text: t('Custom'), value: 'custom' },
  { text: t('Solid'), value: 'solid' },
  { text: t('Print'), value: 'repeat' },
  { text: t('Grab Bag'), value: 'grab-bag' },
  { text: t('Overstock'), value: 'overstock' },
];

const imgUrl = (style: Style) =>
  `${props.blobDomain}static/style/${style.agonswimId}/${style.assembly}-preview.svg`;

const localize = genLocalize(props.localeDto.culture);

const nonEmptyCategories = computed(() =>
  Object.fromEntries(
    Object.entries(filterComp.value).filter(
      ([id, categories]) =>
        categories.length > 0 && id !== 'fabric' && id !== 'lining',
    ),
  ),
);

const filteredItems = computed(() => {
  const filter = filterComp.value;
  if (_.isEmpty(filter)) {
    return props.items;
  }
  //console.log(nonEmptyCategories);
  /*if (_.isEmpty(nonEmptyCategories)) {
            return this.items;
        }*/
  return _.filter(props.items, function (item) {
    //console.log("style:");
    //console.log(style);
    //console.log("Product");
    //console.log(item.product);
    //if (!actualFilter) return false;
    if (!item.product.styleEntity) return false;
    //if (!item.product.hasOwnProperty('fabric')) return false;
    //if (!item.product.hasOwnProperty('lining')) return false;
    //console.log(nonEmptyCategories.value);
    return (
      (_.isEmpty(nonEmptyCategories.value) ||
        _.every(nonEmptyCategories.value, function (selectedChildren) {
          //console.log("children:");
          //console.log(selectedChildren);
          if (selectedChildren.length === 0) return true;
          return (
            _.intersection(
              item.product.styleEntity.categories,
              selectedChildren,
            ).length > 0
          );
        })) &&
      (_.isEmpty(filter.fabric) ||
        _.includes(filter.fabric, item.product.fabric)) &&
      (_.isEmpty(filter.lining) ||
        _.includes(filter.lining, item.product.liningOption))
    );
  });
});
</script>

<style scoped></style>
